import { DataHelper } from './data.helper';

export class HttpHelper {

    public static cleanParams(params: any): any {
        const newParams = {};
        for (const param in params) {
            if (params.hasOwnProperty(param) && params[param] !== undefined && params[param] !== null && params[param] !== '') {
                newParams[param] = params[param];
            }
        }
        return newParams;
    }

    public static changeCase(params: any, type: string = 'snake'): any {
        const newParams = {};
        for (const param in params) {
            if (params.hasOwnProperty(param)) {
                newParams[DataHelper.changeCase(param, type)] = params[param];
            }
        }
        return newParams;
    }
}
